import { AxiosResponse } from "axios";
import { IGetHistoricoAgendamentoParams, IPageHistoricoAgendamentoDTO } from "../../types/historicoAgendamento";
import { removeEmpty } from "../../utils/removeEmpty";
import { ApiBrave } from "../../Apis/Brave";

const basePath = "/historico-agendamento";

export class HistoricoAgendamento {
    static async listar(props: IGetHistoricoAgendamentoParams): Promise<AxiosResponse<IPageHistoricoAgendamentoDTO>> {
        let params = new URLSearchParams(removeEmpty(props)).toString();
        return ApiBrave.get(`${basePath}?${params}`);
    }
}